import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import '../../css/forms/default-forms.css'

export default class ProfileBaseForm extends Component {

  constructor(props) {
    super(props);
    const userData = path(['userData'], props) || {};
    this.state = {
      email: userData.email || '',
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  render() {
    const disabledStyle = {
      backgroundColor: 'rgb(246, 246, 246)',
      borderRadius: '4px',
    };
    const userData = path(['userData'], this.props) || {};
    return (
      <div className="row form-inline" style={{ paddingLeft: '10px', paddingTop: '20px' }}>
        <div className="form-group">
          <label htmlFor="fn">First Name</label>
          <input type="text" value={userData.firstname || ''} id="fn" className="form-control" style={disabledStyle} disabled />
        </div>
        <div className="form-group">
          <label>Last Name</label>
          <input type="text" value={userData.lastname || ''} className="form-control" style={disabledStyle} disabled />
        </div>
        <div className="form-group">
          <label>User Name</label>
          <input type="text" value={userData.username || ''} className="form-control" style={disabledStyle} disabled />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={this.state.email}
            className="form-control"
            onChange={(value) => this.onChange(value)}
            style={{borderRadius: '4px'}}
          />
        </div>
      </div>
    );
  }
}

ProfileBaseForm.propTypes = {
  handler: PropTypes.func,
  userData: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/common/ProfileBaseForm/index.js